import { Button, DatePicker, Form, Input, Modal, Select } from "antd";
import React from "react";

const { Option } = Select;

const UpdateForm = ({
  isModalVisible,
  handleUpdate,
  handleCancel,
  editingRecord,
}) => {
  return (
    <Modal
      title="编辑用户"
      open={isModalVisible}
      onCancel={handleCancel}
      footer={null}
    >
      <Form
        initialValues={editingRecord}
        onFinish={handleUpdate}
        style={{ textAlign: "center" }}
        labelCol={{ span: 7 }} // 控制标签的宽度
        wrapperCol={{ span: 15 }} // 控制输入框的宽度
      >
        <Form.Item
          name="phone_no"
          label="手机账号"
          rules={[
            { required: true, message: "请输入手机账户" },
            {
              pattern: /^\d{11}$/,
              message: "请输入11位数字的手机号",
            },
          ]}
        >
          <Input className="centered-input-simple" />
        </Form.Item>
        <Form.Item
          name="nick_name"
          label="成员昵称"
          rules={[{ required: true, message: "请输入成员昵称" }]}
        >
          <Input className="centered-input-simple" />
        </Form.Item>
        <Form.Item
          name="user_no"
          label="学员学号"
          rules={[
            { required: true, message: "请输入以BJ开头的9位学号" },
            {
              pattern: /^BJ\d{7}$/,
              message: "请输入BJ开头的9位学号",
            },
          ]}
        >
          <Input disabled className="centered-input-simple" />
        </Form.Item>
        <Form.Item
          name="role_id"
          label="权限"
          rules={[{ required: true, message: "请输入权限" }]}
        >
          <Select className="centered-input-simple" placeholder="请选择权限">
            <Option value={"1"}>高级管理员</Option>
            <Option value={"2"}>智慧豆录入员</Option>
            <Option value={"3"}>智慧豆审核员</Option>
            <Option value={"4"}>智慧豆录入和审核员</Option>
          </Select>
        </Form.Item>
        <Form.Item
          name="ctime"
          label="创建时间"
          rules={[{ required: true, message: "请输入创建时间" }]}
        >
          <Input disabled className="centered-input-simple" />
        </Form.Item>
        <Form.Item
          name="mtime"
          label="修改时间"
          rules={[{ required: true, message: "请输入修改时间" }]}
        >
          <Input disabled className="centered-input-simple" />
        </Form.Item>
        <Form.Item
          name="status"
          label="状态"
          rules={[{ required: true, message: "请输入状态" }]}
        >
          <Select
            disabled
            className="centered-input-simple"
            placeholder="请选择状态"
          >
            <Option value={1}>已启用</Option>
            <Option value={0}>未启用</Option>
          </Select>
        </Form.Item>
        <Form.Item
          wrapperCol={{ span: 24 }}
          style={{ textAlign: "center", marginTop: "40px" }}
        >
          <Button
            type="default"
            onClick={handleCancel}
            style={{ marginRight: "30px" }}
          >
            取消
          </Button>
          <Button type="primary" htmlType="submit">
            保存
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UpdateForm;
